import gql from 'graphql-tag'
import * as MODULES from "./subscriptions/moduleHash.js";

export { MODULES };

export const CHAT_INDIVIDUAL_SUB = gql `
subscription ChatIndividualSuscripcion(
  $id_empresa: String!
  $id_usuario: String!
  $limit: String!
) {
  ChatIndividualSuscripcion(
    id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
    limit: $limit
    last_id: "0"
  ) {
    fecha_modificacion
    id_chat
    is_favorito
    usuarios {
      id_usuario
      primer_nombre
      apellido_paterno
      imagen_perfil
      cargo {
        id_cargo
        nombre_cargo
      }
    }
    mensajes {
      id_chat_mensaje
      mensaje
      visto_mensaje
      fecha_creacion
      id_destinatario
      id_remitente
    }
  }
}`



export const CHAT_GRUPAL_SUB = gql `
subscription ChatGrupalSuscripcion(
  $id_empresa: String!
  $id_usuario: String!
  $limit: String!
) {
  ChatGrupalSuscripcion(
    id_empresa_fk: $id_empresa
    id_usuario: $id_usuario
    limit: $limit
    last_id: "0"
  ) {
    id_chat: id_grupo
    fecha_modificacion
    usuarios {
      id_usuario
      primer_nombre
      apellido_paterno
    }
    mensajes {
      id_chat_mensaje: id_chat_grupo_mensaje
      mensaje
      visto_mensaje: visto
      fecha_creacion
      remitente {
        id_usuario
        primer_nombre
        apellido_paterno
      }
    }
  }
}`

export const GET_LISTA_CHATS_SUB = gql `
subscription ListaChatsSuscripcion( $id_empresa: String! $id_usuario: String! $limit: String!) {
  ListaChatsSuscripcion(id_empresa: $id_empresa, id_usuario: $id_usuario, limite: $limit) {
    individual {
      fecha_modificacion
      id_chat
      is_favorito
      usuarios {
        id_usuario
        primer_nombre
        apellido_paterno
        imagen_perfil
        cargo {
          id_cargo
          nombre_cargo
        }
      }
      mensajes {
        id_chat_mensaje
        mensaje
        visto_mensaje
        fecha_creacion
        id_destinatario
        id_remitente
      }
    }

    grupal {
      id_chat: id_grupo
      fecha_modificacion
      usuarios {
        id_usuario
        primer_nombre
        apellido_paterno
      }
      mensajes {
        id_chat_mensaje: id_chat_grupo_mensaje
        mensaje
        visto_mensaje: visto
        fecha_creacion
        remitente {
          id_usuario
          primer_nombre
          apellido_paterno
        }
      }
    } 
 
  }
}`;